var map = {
	"./add.svg": 281,
	"./arrow.svg": 8813,
	"./budget.svg": 4801,
	"./bulb.svg": 1603,
	"./checkmark.svg": 5280,
	"./circle-large.svg": 3239,
	"./circle-medium.svg": 4435,
	"./circle-small.svg": 9121,
	"./close.svg": 9335,
	"./edit.svg": 6937,
	"./error.svg": 8067,
	"./facebook-icon.svg": 2374,
	"./fb-share-background.png": 4472,
	"./fb-share-overlay.png": 855,
	"./gloss.svg": 4150,
	"./handbook-stem.svg": 43,
	"./handbook.svg": 1589,
	"./loading.svg": 4403,
	"./logo/ESF-logo.svg": 1635,
	"./logo/ESI-logo.svg": 6463,
	"./logo/EU-logo.svg": 6598,
	"./logo/GFZG-logo.png": 385,
	"./logo/GFZG-logo.svg": 6480,
	"./logo/GTF-logo.svg": 1871,
	"./logo/Klastera-logo.svg": 6730,
	"./logo/Nacionalna-zaklada-za-razvoj-civilnog-drustva-logo.svg": 4992,
	"./logo/Vlada-RH-Ured-za-udruge-logo.svg": 8076,
	"./logo/raSTEMo-logo.svg": 7981,
	"./love.svg": 1669,
	"./menu-background.png": 3378,
	"./minus.svg": 33,
	"./nerd.svg": 5760,
	"./not-found.svg": 374,
	"./placeholder-icon.png": 7531,
	"./plus.svg": 675,
	"./puzzle.svg": 6955,
	"./quiz-button.svg": 7946,
	"./quiz-result-bad.svg": 226,
	"./quiz-result-good.svg": 2937,
	"./quiz-result-great.svg": 3198,
	"./quiz-result-okay.svg": 5401,
	"./quiz.svg": 9195,
	"./rastemo.svg": 6677,
	"./sparkle.svg": 4682,
	"./spinner.svg": 8894,
	"./start-game.svg": 6401,
	"./start-quiz.svg": 7947,
	"./try-again.svg": 7539,
	"./zoom.svg": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;